<div class="is-flex is-column gap-8">
  <app-toolbar-item (click)="zoomIn()">
    <app-icon class="text-24" name="plus" />
  </app-toolbar-item>

  <app-toolbar-item (click)="zoomOut()">
    <app-icon class="text-24" name="less" />
  </app-toolbar-item>
</div>
